import { breakpointValues, Button, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { AppTilesGridContainer, TEST_IDS } from '../../primitives';
import { AppTileSkeleton, Container } from './PaginatedAppGrid.styles';
const Loading = _ref => {
  let {
    tileCount = 6
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from({
    length: tileCount
  }, (_, index) => /*#__PURE__*/React.createElement(AppTileSkeleton, {
    "data-testid": TEST_IDS.APP_TILE_SKELETON,
    key: index
  })));
};
export const PaginatedAppGrid = _ref2 => {
  let {
    renderGrid,
    isLoading,
    isLoadingMore,
    onLoadMoreClick,
    showLoadMore
  } = _ref2;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const loadingMoreTileCount = breakpoint < breakpointValues.md ? 2 : 3;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, isLoading ? /*#__PURE__*/React.createElement(Loading, null) : renderGrid(), isLoadingMore && /*#__PURE__*/React.createElement(Loading, {
    tileCount: loadingMoreTileCount
  })), /*#__PURE__*/React.createElement(Container, null, showLoadMore && /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    isLoading: isLoadingMore,
    onClick: onLoadMoreClick
  }, "Load More")));
};